import { render, staticRenderFns } from "./Ofer.vue?vue&type=template&id=053d76cf&"
import script from "./Ofer.vue?vue&type=script&lang=js&"
export * from "./Ofer.vue?vue&type=script&lang=js&"
import style0 from "./Ofer.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports